var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-jumbotron',[_c('h1',[_vm._v("Apps")]),_c('hr'),_c('p',[_vm._v(" Download the WireGuard App for your device. ")]),_c('AppList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }